import React from 'react';
import CCEvents, { EventNames } from '@companycam/companycam-events';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@companycam/slab-web';

import { useAddTaskImages } from 'components/projects/taskList/hooks';

import { translate } from 'translations/i18n';

// #region styled-components
const FooterContainer = styled.div`
  width: 100%;
  background: var(--cc_color_background_2);
  position: absolute;
  left: 0;
  bottom: 0;
  padding: var(--cc_size_spacing_m);
  display: flex;
  gap: var(--cc_size_spacing_m);
  justify-content: flex-end;
  align-items: center;
  border-radius: 0 0 var(--cc_size_border_radius_l)
    var(--cc_size_border_radius_l);
  z-index: 100;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  gap: var(--cc_size_spacing_m);
  width: 100%;
`;
// #endregion

const TaskAssetFooter = ({
  getAllSelected,
  clearSelection,
  selectionCount,
  onRequestClose,
  uploadPhotoOption,
  taskId,
}) => {
  const { addTaskImages } = useAddTaskImages({
    onCompleted: () => {
      CCEvents.logEvent(EventNames.TASK_LISTS.IMPORT_TASK_PHOTO);
    },
  });

  const addTaskPhoto = async (nodeId) => {
    await addTaskImages({
      variables: {
        input: {
          id: taskId,
          imageIds: [nodeId],
        },
      },
    });
  };

  const closeTaskAssetModal = () => {
    clearSelection();
    onRequestClose();
  };

  const handlePhotoSelection = () => {
    const photos = getAllSelected();
    if (photos.length) {
      photos.map(({ id }) => addTaskPhoto(id));
    }
    closeTaskAssetModal();
  };

  return (
    <FooterContainer>
      <ButtonContainer>
        <Button
          color="primary"
          disabled={!selectionCount}
          onClick={selectionCount ? handlePhotoSelection : null}
        >
          {translate('common.confirm')}
        </Button>

        <Button onClick={closeTaskAssetModal}>
          {translate('common.cancel')}
        </Button>

        <Button
          color="primary"
          design="minimal"
          icon={{
            name: 'plus-circle',
            position: 'before',
          }}
          onClick={uploadPhotoOption}
          style={{ marginRight: 'auto' }}
        >
          {translate('projects.taskList.taskAssetFooter.uploadPhotos')}
        </Button>
      </ButtonContainer>
    </FooterContainer>
  );
};

TaskAssetFooter.propTypes = {
  onRequestClose: PropTypes.func,
  getAllSelected: PropTypes.func,
  clearSelection: PropTypes.func,
  uploadPhotoOption: PropTypes.func,
  taskId: PropTypes.string,
  selectionCount: PropTypes.number,
};

export default TaskAssetFooter;
